import { log } from 'log';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { prop, path } from 'js/utils/ramda.util';
import { useCustomSelector } from 'js/store/hooks';
import { LIVE_GAMES_REDUCER } from 'js/store/constants';

export const useLiveGamesSubscribe = () => {
    const socket = useCustomSelector(LIVE_GAMES_REDUCER, prop('socket'));
    const isSocketConnected = useSelector(path([LIVE_GAMES_REDUCER, 'isSocketConnected']));

    return useCallback(({ correlationId, tableAliases = [] }) => {
        if (socket && isSocketConnected) {
            const request = {
                correlationId,
                subscribeRequest: {
                    tableAliases
                }
            };

            log('log', '[LIVE | Portal] sending subscribeRequest', request);

            socket.send(request);
        }
    }, [isSocketConnected, socket]);
};
